import React, { useState } from 'react';
import { RotateCw } from 'lucide-react';
import { AppointmentPicker } from 'components/TreatmentPlan';
import { TreatmentPlansActions, AppointmentActions } from 'store/actions';
import toast from 'react-hot-toast';
import { connect } from 'react-redux';
import { eventHash, getNextOutreachDate } from './helper'
import { Button } from 'components/Button';

let enhancer = connect(null, { ...TreatmentPlansActions, ...AppointmentActions });

const Item = ({
  treatmentPlan,
  schedulingAction,
  selectedAction,
  setSelectedAction,
  onClose,
  updateTreatmentPlanProgress,
  patientAppointments,
  onRefresh,
  onSchedule
}) => {
  let { id, icon, label, confirmButtonIcon, confirmButtonText, iconBorderClass, textareaFocusClass, textareaLabel, textareaPlaceholder, bgClass } = schedulingAction || {}
  const { encoded_id: treatmentPlanId, active_treatment_plan_progress, min_follow_up_days, base_appointment } = treatmentPlan || {}
  const { encoded_id: activeTreatmentPlanProgressId } = active_treatment_plan_progress?.data?.attributes || {}

  const [notes, setNotes] = useState('')
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [loader, setLoader] = useState(false);

  const updateTxpPlanProgress = async () => {
    setLoader(true)
    try {
      const payload = {
        treatment_plan_progress: {
          treatment_plan_id: treatmentPlanId,
          originated_appointment_id: base_appointment?.data?.id,
          patient_decision_type: selectedAction,
          notes: notes,
          ...(selectedAction === "scheduled" && { future_appointment_id: selectedAppointment?.id }),
          ...(selectedAction === "deferred" && { scheduled_next_outreach_at: getNextOutreachDate(min_follow_up_days) }),
        },
        event: eventHash[selectedAction],
      };

      let data = await updateTreatmentPlanProgress(treatmentPlanId, activeTreatmentPlanProgressId, payload)
      onClose()

      if (selectedAction == 'scheduled') {
        onSchedule(1)
      } else {
        onSchedule(-1)
      }
    } catch (error: any) {
      toast.error(error.errors || 'Failed to update treatment plan progress');
    }
    setLoader(false)
  }

  const isDisabled = notes.trim().length <= 0 && id === 'deferred';
  const btnClass = isDisabled ? 'bg-[#fcd34d] opacity-60 cursor-not-allowed text-white/90' : bgClass;

  return (
    <div className="border border-slate-100 rounded-xl p-4 bg-white shadow-sm transition-all duration-300">
      <div className="flex items-center gap-2 cursor-pointer"
        onClick={() => { setNotes(""); setSelectedAction(id); }}
      >
        <div className="flex items-center justify-center w-5 h-5 shrink-0">
          {selectedAction === id ? (
            <svg className="w-5 h-5 text-secondary-900" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" />
              <circle cx="10" cy="10" r="4.5" fill="currentColor" />
            </svg>
          ) : (
            <svg className="w-5 h-5 text-secondary-300" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" />
            </svg>
          )}
        </div>

        <div className={`flex items-center justify-center w-4 h-4 rounded-full border shrink-0 ${iconBorderClass}`}>
          {icon}
        </div>
        <span className="font-bold text-xs text-secondary-900">{label}</span>
      </div>

      {selectedAction === id && (
        <div className="mt-4 space-y-4">
          {id === 'scheduled' && (
            <>
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="text-xs font-bold text-secondary-900">Select Appointment from PMS</h4>
                  <p className="text-[10px] text-secondary-400 mt-0.5">Last updated: 15:52:54</p>
                </div>

                <button
                  onClick={onRefresh}
                  className="flex items-center gap-1.5 px-3 py-1.5 border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors text-[10px] font-bold text-secondary-800"
                >
                  <RotateCw className={`w-3 h-3`} />
                  Refresh
                </button>
              </div>

              <AppointmentPicker
                patientAppointments={patientAppointments}
                selectedAppointment={selectedAppointment}
                setSelectedAppointment={setSelectedAppointment}
              />
            </>
          )}

          <div className="flex flex-col gap-1.5">
            <label className="text-[10px] font-bold text-secondary-900">{textareaLabel}</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder={textareaPlaceholder}
              className={`w-full min-h-[80px] rounded-lg border border-slate-200 p-3 text-xs text-secondary-900 placeholder:text-secondary-400 focus:outline-none transition-colors resize-none ${textareaFocusClass}`}
            />
          </div>

          <Button
            title={confirmButtonText}
            variant="secondary"
            onClick={updateTxpPlanProgress}
            icon={confirmButtonIcon}
            loading={loader}
            disabled={isDisabled}
            className={`w-full py-2.5 rounded-lg font-bold text-xs flex items-center justify-center gap-2 transition-all shadow-sm ${btnClass}`}
          />
        </div>
      )}
    </div>
  );
};

export default enhancer(Item);
